import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withSettingsColor from '../../../hoc/with-settings-color';
import { isIos as getIsIos } from '../../../../common/services/detect-platform';
import { FORMATTING_BUTTONS } from 'wix-rich-content-editor-common';
import styles from './external-formatting-toolbar.scss';

const isIos = getIsIos();
// disable showing selection status for these button, as rce will not apply styling due to draftjs and gboard limitations on android
const DISABLE_STATUS_ON_ANDROID = [
  FORMATTING_BUTTONS.BOLD,
  FORMATTING_BUTTONS.ITALIC,
  FORMATTING_BUTTONS.UNDERLINE,
];

const getIsActive = (name, isActive) => {
  if (isIos) {
    return isActive();
  }
  return DISABLE_STATUS_ON_ANDROID.includes(name) ? false : isActive();
};

const ExternalToolbar = ({ buttons, buttonColor }) => {
  const renderButton = ({ name, onClick, isActive, getIcon, dataHook }) => {
    const Icon = getIcon();
    const buttonIsActive = getIsActive(name, isActive);
    return (
      <button
        data-hook={dataHook}
        className={styles.pluginButton}
        style={{ backgroundColor: buttonIsActive ? buttonColor : '' }}
        onClick={onClick}
        // onMouseDown handler must be used to maintain focus on editor input for mobile
        onMouseDown={e => e.preventDefault()}
      >
        <Icon
          className={classNames(
            'forum-icon-fill',
            buttonIsActive && 'button-fill',
            buttonIsActive && 'button-color',
          )}
        />
      </button>
    );
  };

  return <div className={styles.container}>{Object.values(buttons).map(renderButton)}</div>;
};

ExternalToolbar.propTypes = {
  buttons: PropTypes.object.isRequired,
  renderPluginButtons: PropTypes.bool.isRequired,
};

export default withSettingsColor({
  propName: 'buttonColor',
  siteColorFallback: 'color-8',
  siteColorAlpha: 0.2,
  fallbackColor: '27a456',
})(ExternalToolbar);
